import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoMedicalBenefits = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>MedicalBenefits</title>
    <path
      d="M13.713 5.565a2.286 2.286 0 0 0-2.285 2.286v4.571H6.856a2.286 2.286 0 0 0-2.285 2.286v4.571a2.286 2.286 0 0 0 2.285 2.286h4.572v4.571a2.286 2.286 0 0 0 2.285 2.286h4.572a2.286 2.286 0 0 0 2.285-2.286v-4.571h4.572a2.286 2.286 0 0 0 2.285-2.286v-4.57a2.286 2.286 0 0 0-2.285-2.287H20.57v-4.57a2.286 2.286 0 0 0-2.285-2.287h-4.572Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoMedicalBenefits;
